document.addEventListener('DOMContentLoaded', () => {
  let lang = document.documentElement.lang;
  //RESET PASSWORD VALIDATION EMAIL
  const resetemailInput = document.getElementById('RecoverEmail');
  const resetemailError = document.getElementById('email-error-reset');
  const resetsubmitButton = document.querySelector('.recover-button');
  
  resetemailInput.addEventListener('focus', () => {
    const emailValue = resetemailInput.value.trim();
    if (emailValue === '' || !isValidEmail(emailValue)) {
    if (lang === 'pl') {
        resetemailError.textContent = 'Wprowadź poprawny email';
    } else if (lang === 'en') {
        resetemailError.textContent = 'Please enter a valid email address';
    }
      
      resetemailInput.classList.add('error-border');
      resetsubmitButton.disabled = true;
    } else {
      resetemailError.textContent = '';
      resetemailInput.classList.remove('error-border');
      resetsubmitButton.disabled = false;
    }
  });

  resetemailInput.addEventListener('input', () => {
    const emailValue = resetemailInput.value.trim();
    if (emailValue === '' || !isValidEmail(emailValue)) {
      if (!resetemailInput.classList.contains('error-border')) {
        resetemailInput.classList.add('error-border');
      }
      if (lang === 'pl') {
        resetemailError.textContent = 'Wprowadź poprawny email';
    } else if (lang === 'en') {
        resetemailError.textContent = 'Please enter a valid email address';
    }

      resetsubmitButton.disabled = true;
    } else {
      resetemailError.textContent = '';
      resetemailInput.classList.remove('error-border');
      resetsubmitButton.disabled = false;
    }
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  //RESET PASSWORD SUBMIT VALIDATION
  const sourceParamReset = new URLSearchParams(window.location.search).get('source');
  const successMessage = document.querySelector('.recover-success');
  
  if (sourceParamReset === 'error-reset') {
    resetemailInput.classList.add('error-border');
    if (lang === 'pl') {
        resetemailError.textContent = 'Brak konta powiązanego z podanym mailem';
    } else if (lang === 'en') {
        resetemailError.textContent = 'There is no account associated with the provided email address';
    }

    loginpasswordInput.addEventListener('focus', () => {
      resetemailInput.classList.remove('error-border');
      resetemailError.textContent = '';
    });
  }

  if (sourceParamReset === 'success') {
    successMessage.classList.add('active');
  }
});